import { create } from "zustand";
import { SocketNotificationData } from "@/shared/types";

interface NotificationStoreState {
  currentTaanaNotification: SocketNotificationData | null;
  currentNotification: SocketNotificationData | null;
  setCurrentNotification: (notification: SocketNotificationData) => void;
  setCurrentTaanaNotification: (notification: SocketNotificationData) => void;
  clearCurrentNotification: () => void;
}

export const useNotificationStore = create<NotificationStoreState>((set) => ({
  currentNotification: null,
  currentTaanaNotification: null,
  setCurrentNotification: (notification) =>
    set({ currentNotification: notification }),
  setCurrentTaanaNotification: (notification) =>
    set({ currentTaanaNotification: notification }),
  clearCurrentNotification: () => set({ currentNotification: null }),
  clearCurrentTaanaNotification: () => set({ currentTaanaNotification: null }),
}));
